<template>
  <div class="index">
    <van-nav-bar title="交押金" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <div class="conter">
      <van-form @submit="onSubmit" class="form">
        <van-field
          v-model="payForm.carNum"
          name="卡号"
          label="卡号"
          placeholder="请输入卡号"
          :rules="[{ required: true, message: '请输入卡号' }]"
        />
        <div style="margin: 2rem 16px 1rem">
          <van-button round block type="info" native-type="submit">确认卡号</van-button>
        </div>
      </van-form>
    </div>


  </div>
</template>

<script>


  function getUrlKey (name) {//获取url 参数
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  function getCodeApi (state) {//获取code
    let urlNow = encodeURIComponent(window.location.href)
    let scope = 'snsapi_base'    //snsapi_userinfo   //静默授权 用户无感知
    let appid = 'wxd104040ca687111a'
    let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
    window.location.replace(url)
  }

  import wx from 'weixin-js-sdk'

  export default {
    data () {
      return {
        // 倒计时
        time: 60 * 1000,
        payForm: {
          carNum: '',
        },
        openId: '',
      }
    },
    created () {
    },
    mounted () {
      let code = getUrlKey('code')//获取url参数code
      if (code) { //拿到code， code传递给后台接口换取opend
        this.code = code

        let currentUrl = location.href.split('#')[0]

        let data = new FormData()
        data.append('code', this.code)
        data.append('url', currentUrl)
        this.$axios.post('/api/smartcard/getOpenIdByCode', data).then(res => {
          if (res.data.success) {
            this.openId = res.data.userObject.openId
          } else {
            this.$toast.fail('加载openId失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          console.log(error)
          this.$toast.fail('加载openId失败!')
        })
      } else {
        getCodeApi('qksmartcardfill2020')

      }
    },
    methods: {
      // 提交押金申请
      onSubmit () {
        let data = {
          cardNumber: this.payForm.carNum
        }
        this.$axios.post('/lockapi/smartlock/get-card-info-for-create', data).then(res => {
          if (res.data.success) {
            this.$router.push({path: '/intelligentLock/payDepositForm'})
            sessionStorage.setItem('carMsg', JSON.stringify(res.data.userObject))
            sessionStorage.setItem('openId', this.openId)
          } else {
            this.$toast.fail('查询失败的原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          console.log(error)
          this.$toast.fail('查询失败!')
        })
      },
      //   后退
      onClickLeft () {
        location.href = '/#/intelligentLock/portal'
      }

    },
  }
</script>
<style lang="less" scoped>
  .index {
    .form {
      // background-color: #fff;
      .van-field {
        font-size: 0.6rem;
      }
    }

    .van-field {
      text-align: left;
    }

    .conter {
      margin-top: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/intelligentLock/payDeposit.vue